import e from "./style.module.css";
import Button from "components/common/Button/Button";
import animatedHome from "assets/img/incHomeAnimate2.svg";
import icn24hServ from "assets/img/24h_serv.svg";
import { ServicesLinks } from "./ServicesLinks/ServicesLinks";

export const Home = () => {
  const callReclamations = () => {
    document.location.href = "tel:1829568440";
  };
  const storedUserType = localStorage.getItem("user") || "{}";
  const userName = JSON.parse(storedUserType)?.user?._nombre || "";

  return (
    <>
      <div className={e.home_container}>
        <div className={e.topSection}>
          <div className={e.wel__container}>
            <div>
              <h2 className="text-capitalize">Hola {userName}</h2>
              <h5 className={e.wel__text}>
                Bienvenido Segurnet virtual, tu página de servicios.
              </h5>
            </div>
            <div className={e.wel__callButton}>
              <div>
                <img
                  src={icn24hServ}
                  alt="Icono de audifonos, servicio 24 horas"
                  className={e["call__btn-icon"]}
                />
              </div>
              <div>
                <p className={`${e["call__btn-text"]} bold`}>
                  En caso de accidente, ¿Necesitas asistencia?
                </p>
                <Button
                  type="button"
                  value="contactar reclamaciones"
                  className={e.button}
                  onClick={callReclamations}
                />
              </div>
            </div>
          </div>

          <div className={e.gif__container}>
            <img
              className={e.home__gif}
              src={animatedHome}
              alt="Servicios imagen secretaria"
            />
          </div>
        </div>
      </div>
      <ServicesLinks />
    </>
  );
};
